export default __webpack_public_path__ + "static/pt_sam42_sales-e3b075b05d73309186053da4e57b3143.jpg";